export const SET_AUTH = 'setAuth'
export const RESET_AUTH = 'resetAuth'
export const CLEAR_SESSION = 'clearSession'
export const SET_PAGINATION = 'setPagination'
export const SET_LIST_DATA = 'setListData'
export const SHOW_DELETE_DIALOG = 'showDeleteDialog'
export const HIDE_DIALOG = 'hideDialog'
export const SHOW_LOADER = 'showLoader'
export const HIDE_LOADER = 'hideLoader'
export const REMEMBER_LIST = 'rememberOrder'
export const SITE_NEW_CONTENT = 'siteNewContent'
export const SCANNED_VALUE = 'scannedValue'
